export enum LayerThickness {
  Micron50 = 1,
  Micron100 = 3,
  Micron170 = 4,
}
